export const removeQueryParamsFromUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return url;
  }

  const [urlWithoutQueryParams] = url?.split('?');
  return urlWithoutQueryParams;
};
